<template>
  <section>
    <div class="row" style="border-bottom: 1px solid #EEEEEE; padding: 0.5rem 0;">
      <div class="col-12">
        <router-link :to="'/cleaner/'+id">
          <div class="avatar-container small">
            <div :class="['dot', (professional.active === 1) ? 'active' : 'inactive']"></div>
            <img v-lazy="professional.picture" class="rounded-circle message-user-img">
          </div>
          &nbsp;{{ professional.name | firstName }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['id'],
    computed: {
      ...mapGetters({
        professional: 'professional/getProfessional'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/message/CleanerDetailMobile.vue